<mh-dashboard-widget-card [ready]="ready()">
  <mh-chart-value-widget
    [title]="'cases.commons.cases' | translate"
    [subtitle]="'commons.resolved' | translate"
    [description]="rawData()?.description"
    [percentage]="true"
    [product]="'cases'"
    [enabled]="enabled()"
    [value]="displayValue()"
    [loading]="loading()"
    [error]="error()"
    [changePercentage]="changePercentage()"
    [increase]="isIncrease()"
    [route]="'/cases/summary'"
    [demoRoute]="'/plg/desk'"
    [chartData]="chartData()"
    [chartOptions]="chartOptions()"
    [gaKey]="'corporatedash-viewdesk-active'"
  />
</mh-dashboard-widget-card>
